<script lang="ts">
    import src from './svg/dot.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
    export let title: string = '';
</script>

<TemplateIcon {src} {scale} alt={title} hover={title} on:click />

<!--<script lang="ts">-->
<!--    export let color = '#000;';-->
<!--    export let size = 8;-->
<!--</script>-->

<!--<svg width="32" height="32" xmlns="http://www.w3.org/2000/svg">-->
<!--    <circle cx="16" cy="16" r={size} fill={color} />-->
<!--</svg>-->

